/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NamirasoftEmailSenderServer } from "./NamirasoftEmailSenderServer";
import { NamirasoftEmailSenderServerBase } from "./NamirasoftEmailSenderServerBase";

export class NamirasoftEmailSenderServerEmail extends NamirasoftEmailSenderServerBase
{
    constructor(server: NamirasoftEmailSenderServer)
    {
        super(server);
        this.Send = this.Send.bind(this);
        this._SendFor = this._SendFor.bind(this);
    }
    async Send(body: { provider_id: string, email: string, title: string, message: string, html: boolean }): Promise<{ id: string }>
    {
        let path = `/send`;
        let { data } = await this.server._post<{ id: string }>(path, {}, body);
        return data;
    }
    async _SendFor(user_id: string, body: { provider_id: string, email: string, title: string, message: string, html: boolean }): Promise<{ id: string }>
    {
        let path = `/application/user/${user_id}/send`;
        let { data } = await this.server._post<{ id: string }>(path, {}, body);
        return data;
    }
};